module.exports = __webpack_public_path__ + "img/07.38172ff5.png";